import {Component, Input, OnInit, ElementRef} from '@angular/core';
import { PageNotificationService, GadgetApiService} from '@signature-it/ngx-generic/services';
import { Router, NavigationExtras } from '@angular/router';

declare let _ : any;

@Component({
    selector: 'bar-gadget',
    templateUrl: './bar.gadget.html',
    styleUrls: ['./bar.gadget.scss'],
    standalone: false
})
export class BarGadget implements OnInit {
  @Input() title: string;
  @Input() btnText: string;
  @Input() btnLink: string;
  @Input() colors: string[];
  @Input() key: string;
  cardNum: number;
  cardText: string;
  data: any = {};
  showGadget: boolean = false;
  currencySymbols = {
    'USD': '$', // US Dollar
    'EUR': '€', // Euro
    'CRC': '₡', // Costa Rican Colón
    'GBP': '£', // British Pound Sterling
    'ILS': '₪', // Israeli New Sheqel
    'INR': '₹', // Indian Rupee
    'JPY': '¥', // Japanese Yen
    'KRW': '₩', // South Korean Won
    'NGN': '₦', // Nigerian Naira
    'PHP': '₱', // Philippine Peso
    'PLN': 'zł', // Polish Zloty
    'PYG': '₲', // Paraguayan Guarani
    'THB': '฿', // Thai Baht
    'UAH': '₴', // Ukrainian Hryvnia
    'VND': '₫', // Vietnamese Dong
  };

  constructor(
              protected notifySvc: PageNotificationService,
              public router: Router,
              protected gadgetApiSvc: GadgetApiService,
              protected element: ElementRef) {

  }

  ngOnInit() {
    if (this.colors) {
      this.data.colors = this.colors;
    }
    this.getData();
  }



  getData() {
      this.gadgetApiSvc.getBarData()
        .subscribe(
            res => {
              if (res && _.isObject(res)) {
                  this.showGadget = true;
                  this.data = {...this.data, ...res};
                  this.data.usageLabel = (+this.data.usage).toLocaleString();
                  this.data.currentLabel = (+this.data.current).toLocaleString();
                  if (this.currencySymbols[this.data.typeLabel]) {
                    this.data.typeLabel = this.currencySymbols[this.data.typeLabel];
                  }
                  this.setChartData();
              }
            },
            error => {
              this.notifySvc.set(error).show();
            }
        );
  }

  setChartData() {
    let bar = this.element.nativeElement.getElementsByClassName('bar')[0];
    let section1 = bar.getElementsByClassName('section-1')[0];
    let section2 = bar.getElementsByClassName('section-2')[0];
    let arrow = bar.getElementsByClassName('usage-arrow')[0];
    let usageText = bar.getElementsByClassName('usage-text')[0];

    if (this.data.colors) {
      section1.style.backgroundColor = this.data.colors[0];
      section2.style.backgroundColor = this.data.colors[1];
    }
    section1.style.width = `${this.getPercent(this.data.limit)}%`;
    section2.style.width = `${(100 - this.getPercent(this.data.limit))}%`;
    let arrowPercents = this.getPercent(this.data.usage);
    if (arrowPercents > 100) arrowPercents = 100;
    arrow.style.left = `calc(${arrowPercents}% - 8px)`;
    if (this.getPercent(this.data.usage) < 50) {
      usageText.style.left = `calc(${this.getPercent(this.data.usage)}% - 8px)`;
    } else {
      let usagePercents = 100 - this.getPercent(this.data.usage);
      if (usagePercents < 0) usagePercents = 0;
      usageText.style.right = `calc(${usagePercents}% - 8px)`;
    }

    if (this.data.labels) {
      let newlabel;
      this.data.labels.forEach((item) => {
        newlabel = document.createElement('div')
        newlabel.setAttribute('class', 'label');
        newlabel.textContent = this.data.typeLabel + (+item).toLocaleString();
        let itemOnPercent = this.getPercent(item);
        newlabel.style.left = itemOnPercent ? `calc(${itemOnPercent}% - 22px)` : '0px';
        newlabel.style.position = 'absolute';
        newlabel.style.top = '44px';
        newlabel.style.fontSize = '0.8rem';
        bar.appendChild(newlabel);
      })
    }
  }

  getPercent(val) {
    return 100 * +val / +this.data.max;
  }

  onBtnClick() {
    let navigationExtras: NavigationExtras = {
      queryParams: { 'subject' : 'request for additional credit' },
    };

    this.router.navigate([this.btnLink], navigationExtras);
  }

}
